export default {"src":"/_next/static/media/CalendarDate.72b72c85.svg","height":17,"width":15,"blurWidth":0,"blurHeight":0};